<script>
import Form from '@components/form'

/**
 * Modal component
 */
export default {
  components: {
    Form
  },
  props: {
    titleModal: {
      type: String,
      default: '',
    },
    updateForm: {
      type: Array,
      default: () => {
        return []
      }
    },
    inputs: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      innerInputs: this.$attrs['form-config'].formMode !== 'Cost' ? this.$attrs.inputs : []
    }
  },
  computed: {
    title() {
      return this.$attrs['form-config'].formMode !== 'Cost' ? this.$attrs['form-config'].formMode + ' ' + this.titleModal : 'Cost Planner ('+this.$attrs['form-config'].fieldName+')'
    },
    submitValid() {
      return this.$attrs['submit-valid'] || false
    },
    refModal() {
      return this.$attrs['ref-modal'] || 'modal'
    },
    innerActions() {
      return this.$attrs['form-config'].formMode === 'Cost' || false
    }
  },
  watch: {
    updateForm: {
      immediate: true,
      deep: true,
      handler: function (val) {
        this.innerInputs = val
      }
    },
    inputs: {
      immediate: true,
      deep: true,
      handler: function (val) {
        this.innerInputs = val
      }
    },
    submitValid: function() {
      if (!this.submitValid) {
        return false
      } else {
        this.closeModal()
      }
    }
  },
  created:function(){
    // console.log("this.$attrs['form-config']",this.$attrs['form-config'])
  },
  methods: {
    closeModal() {
      if (this.$attrs['ref-modal']) {
        this.$refs[this.refModal].hide()
      } else {
        this.$refs.modal.hide()
      }
    },
    formUpdate(form) {
      this.$emit('update-form', form)
    },
    addTag(tag) {
      this.$emit('add-tag', tag)
    },
    modalOpened(val) {
      this.$emit('modal-open', true)
    },
    modalClosed() {
      this.$emit('modal-close', true)
    },
    modalShow() {
      this.$emit('modal-show', true)
    },
    modalHide() {
      this.$emit('modal-hide', true)
    },
    resetForm() {
      this.$refs.formRef.resetForm()
    },
    async submitForm (bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      const isValid = await this.$refs.formRef.$refs.observer.validate();
      if (!isValid) {
        // ABORT!!
        return false
      }
      this.$refs.formRef.submitForm()
      await this.$emit('submit-form', this.$refs.formRef.formValue)
    }
  }
}
</script>

<template>
  <b-modal
    :id="refModal"
    :ref="refModal"
    v-bind="$attrs"
    :size="$attrs['form-config'].modalSize"
    :title="title"
    title-class="font-18"
    body-class="p-4"
    no-close-on-backdrop
    @shown="modalOpened"
    @hidden="modalClosed"
    @show="modalShow"
    @hide="modalHide"
  >
    <Form v-if="!innerActions" ref="formRef" :ref-id="'observer'" v-bind="$attrs"
      :inputs="innerInputs"
      @add-tag="addTag"
      @update-data="formUpdate"
      @update-select="formUpdate" />
    <slot name="additional"></slot>
    
    <!-- Pass on all scoped slots -->
    <template v-for="slot in Object.keys($scopedSlots)" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>

    <template v-if="!innerActions" v-slot:modal-footer="{ ok, cancel, hide }">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="sm" variant="success" @click="submitForm">
        Submit
      </b-button>
      <!-- Button with custom close trigger value -->
      <b-button size="sm" variant="outline-secondary" @click="hide">
        Cancel
      </b-button>
    </template>
  </b-modal>
</template>
